module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.11-77.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.11.md
// module id = 494
// module chunks = 356